import { ToolsAction, ToolsActionType } from "../actions/tools.actions";

const initialState: any = {
    searchingKeyword: ""
};

export function ToolsReducer(
    state: any = initialState,
    action: ToolsAction
) {
    switch (action.type) {
        case ToolsActionType.SEARCHING:
            return {
                ...state,
                searchingKeyword: action.payload
            }
        default:
            return state;
    }
}